// Standard width variants for RHF form fields

export const widthMap = {
  full: {
    width: '300px', // full width inside drawer
  },
  half: {
    width: '142px', // balanced two per row
  },
  twoThirds: {
    width: '178px', // larger field for 2:1 layouts
  },
  oneThird: {
    width: '105px', // smaller field for 2:1 layouts
  },
};